import { ICountryOption } from "commons/clients/signupClient/types";
import { ECountryCode, IAddress } from "../types";

export type TAddressFormatter = (value: IAddress) => string;

export const ADDRESS_FORMATTERS: Partial<Record<ECountryCode | "default", TAddressFormatter>> = {
  [ECountryCode.GB]: ({ line1, line2, city, country, postcode }) => {
    return [
      formatValue(line1),
      formatValue(line2),
      formatValue(city),
      formatValue(postcode, !country.trim()),
      formatValue(country, true).toUpperCase()
    ]
      .join("")
      .trim();
  },
  [ECountryCode.FR]: ({ line1, line2, city, country, postcode }) => {
    return [
      formatValue(line1),
      formatValue(line2),
      formatValue(postcode, true),
      formatValue(city).toUpperCase(),
      formatValue(country, true).toUpperCase()
    ]
      .join("")
      .trim();
  },
  default: ({ line1, line2, city, country, postcode }) => {
    return [
      formatValue(line1),
      formatValue(line2),
      formatValue(city),
      formatValue(postcode, !country.trim()),
      formatValue(country, true)
    ]
      .join("")
      .trim();
  }
};

export function formatValue(value: string = "", skipSeparator = false) {
  const trimmedValue = value.trim();
  const separator = !skipSeparator ? ", " : " ";

  return trimmedValue ? trimmedValue + separator : "";
}

export function formatAddress(address: IAddress, countries: ICountryOption[]) {
  const { country } = address;
  const countryUpper = country.toUpperCase();
  const countryName = countries.find(item => item.code.toUpperCase() === countryUpper)?.name ?? "";

  const formatter =
    ADDRESS_FORMATTERS[countryUpper as ECountryCode] ?? ADDRESS_FORMATTERS["default"]!;

  return formatter({
    ...address,
    country: countryName
  });
}
